import { Injectable } from "@angular/core";
import { InvoiceCashDeskService } from "./invoice-cash-desk.service";
import { InvoiceCashDesk } from "../../model/invoice-cash-desk";
import { HttpClient } from "@angular/common/http";
import { DataService } from "../data.service";
import { CashDeskUserOpen } from "../../model/cash-desk-user-open";
import { InvoiceNumberBookPoint } from "../../model/invoice-number-book-point";
import { ReportViewer } from "../../model/report-viewer";

@Injectable()
export class InvoicePatientCashDeskService extends InvoiceCashDeskService {
  private readonly getNewInvoiceCashDeskEndPoint: string =
    "/invoiceCashDesk/getNewPatientInvoiceCash/";
  private readonly createPatientInvoiceCashEndPoint: string =
    "/invoiceCashDesk/CreatePatientInvoiceCash/";
  private readonly getInvoiceCashDeskPdfEndPoint: string =
    "/invoiceCashDesk/getPatientInvoiceCashDeskPdf/";
  private readonly existsCurrentInvoiceEndPoint: string =
    "/invoiceCashDesk/existsCurrentInvoice/";

  private readonly sendMailPatientInvoiceCashDeskPdfEndPoint: string =
    "/invoiceCashDesk/sendMailPatientInvoiceCashDeskPdf/";

  async existsCurrentInvoice(medicalAppointmentId: number): Promise<boolean> {
    const params = { medicalAppointmentId: medicalAppointmentId };
    return await this.dataService
      .get<boolean>(this.existsCurrentInvoiceEndPoint, params)
      .toPromise();
  }

  async sendMailPatientInvoiceCashDeskPdf(
    invoiceId: number,
    appointmentId?: number,
    atentionCode?: string,
    email?: string
  ): Promise<boolean> {
    const params = {
      InvoiceId: invoiceId,
      AppointmentId: appointmentId,
      AtentionCode: atentionCode,
      Email: email
    };
    return await this.dataService
      .post<boolean>(this.sendMailPatientInvoiceCashDeskPdfEndPoint, params)
      .toPromise();
  }

  async getInvoiceCashDeskPdf(invoiceId: number): Promise<ReportViewer> {
    const params = { invoiceId: invoiceId };
    return await this.dataService
      .get<ReportViewer>(this.getInvoiceCashDeskPdfEndPoint, params)
      .toPromise();
  }

  async getInvoiceCashDesk(
    medicalAppointmentId?: number,
    invoiceId?: number,
    code?: string
  ): Promise<InvoiceCashDesk> {
    const params = { medicalAppointmentId: medicalAppointmentId };
    return await this.dataService
      .get<InvoiceCashDesk>(this.getNewInvoiceCashDeskEndPoint, params)
      .toPromise();
  }

  async getCashDeskUserOpen(
    allInvoicePoint: boolean,
    allService: boolean,
    equipmentId?: number,
    serviceId?: number,
    invoicePointId?: number
  ): Promise<CashDeskUserOpen> {
    return await this.cashDeskService.getCashDeskUserOpenBySectorAndEquipment(
      this.authService.getSectorId(),
      equipmentId,
      this.authService.canSelectAllInvoicePoint()
    );
  }

  async createInvoiceCash(invoiceCashDesk: InvoiceCashDesk): Promise<number> {
    return await this.dataService
      .post<number>(this.createPatientInvoiceCashEndPoint, invoiceCashDesk)
      .toPromise();
  }

  async getNextNumber(
    cashDeskInvoicePointId: number,
    invoiceLabelTypeId: number
  ): Promise<InvoiceNumberBookPoint> {
    return this.invoicePointService.getNextInvoiceNumber(
      cashDeskInvoicePointId,
      invoiceLabelTypeId
    );
  }

  canEdit(): boolean {
    return true;
  }

  canEditAmount(): boolean {
    return false;
  }

  canEditInvoicePoint(): boolean {
    return this.authService.canSelectAllInvoicePoint();
  }

  isPatient(): boolean {
    return true;
  }
}
